import * as React from 'react'
import type { SVGProps } from 'react'
function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="MS_Klimadashboard_Icons_luftqualitaet_negativ_svg__Ebene_1"
      viewBox="0 0 64.75 69.31"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>
          {
            '.MS_Klimadashboard_Icons_luftqualitaet_negativ_svg__cls-1{fill:#f28443; stroke-width:0}'
          }
        </style>
      </defs>
      <path
        className="MS_Klimadashboard_Icons_luftqualitaet_negativ_svg__cls-1"
        d="M32.58 13.47c.4 0 .81.2 1.05.59l22.52 37.3c.74 1.22-.13 2.78-1.54 2.78H10.05c-1.19 0-1.92-1.32-1.3-2.34l22.78-37.74c.24-.4.64-.59 1.05-.59m0-2.5c-1.32 0-2.51.67-3.19 1.8L6.61 50.51a4.07 4.07 0 0 0-.06 4.09 4.027 4.027 0 0 0 3.5 2.05H54.6c1.55 0 2.98-.84 3.75-2.19.77-1.36.74-3.04-.06-4.38L35.77 12.77a3.687 3.687 0 0 0-3.19-1.8Z"
      />
      <path
        className="MS_Klimadashboard_Icons_luftqualitaet_negativ_svg__cls-1"
        d="M35.17 46.91c0 1.37-1.13 2.51-2.5 2.51s-2.5-1.13-2.5-2.51 1.14-2.49 2.5-2.49 2.5 1.12 2.5 2.49Zm-2.56-4.89c-.93 0-1.69-.68-1.69-1.53V27.85c0-.84.76-1.53 1.69-1.53.93 0 1.69.68 1.69 1.53v12.64c0 .84-.76 1.53-1.69 1.53Z"
      />
    </svg>
  )
}
export default Icon
